export default __webpack_public_path__ + "5bbaf24cc9429129b26011febeea5be5.jpg";